import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import DatetimeHelper from "~/helpers/datetimeHelper";
import PropertyUpdate from "~/models/propertyUpdate";
import {MultiPicklistUpdateMode} from "~/enums/multiPicklistUpdateMode";
import {StringHelper} from "~/helpers/stringHelper";
import {ArrayHelper} from "~/helpers/arrayHelper";

export default {
  methods: {
    isPickList(property_client_id: string): boolean {
      return this.getObjectModelPropertyType(property_client_id) === ObjectModelPropertyRootType.PickList;
    },
    isDateTime(property_client_id: string): boolean {
      return this.getObjectModelPropertyType(property_client_id) === ObjectModelPropertyRootType.DateTime;
    },
    getObjectModelPropertyType(property_client_id: string): ObjectModelPropertyRootType {
      return this.getObjectModelProperty(property_client_id).property_type;
    },
    getObjectModelProperty(property_client_id: string): ObjectModelProperty {
      return this.selectedObjectModel.objectModelPropertiesArray.find(x => x.client_id === property_client_id);
    },
    removePropertyUpdate(propertyUpdate): void {
      propertyUpdate.destroy()
    },
    // todo: remove this after everything is switched to propertyUpdatesDescription
    displayUpdatedPropertyValue(propertyUpdate: PropertyUpdate): string {
      const property = this.getObjectModelProperty(propertyUpdate.property_client_id);

      if (propertyUpdate.value_to_update_to_formula && (propertyUpdate.value_to_update_to_formula.length > 0)) {
        return "(formula)";
      }

      switch (property.property_type) {
        case ObjectModelPropertyRootType.PickList:
          const selectedPickListOptions = property.objectModelPropertiesArray.filter(x => propertyUpdate.values_to_update_to_array.includes(x.client_id));
          return selectedPickListOptions.map(x => x.label_title).join(", ");
        case ObjectModelPropertyRootType.DateTime:
          return DatetimeHelper.formatDate(
            DatetimeHelper.parseDate(propertyUpdate.value_to_update_to),
            DatetimeHelper.timezone,
            DatetimeHelper.displayFormat(property.datetime_mode),
          );
        default:
          return propertyUpdate.value_to_update_to;

      }
    },
    propertyUpdatesDescription(updates: PropertyUpdate[]): string {
      const strings = updates.map((propertyUpdate) => {
        if (!propertyUpdate.property_client_id) {
          return null;
        }
        const property = this.getObjectModelProperty(propertyUpdate.property_client_id);

        let picklistValues: string;
        if (property.property_type === ObjectModelPropertyRootType.PickList) {
          const selectedOptions = property.objectModelPropertiesArray.filter(x => propertyUpdate.values_to_update_to_array.includes(x.client_id));
          picklistValues = selectedOptions.map(x => x.labelTitleDisplay).join(', ');
        }

        if (propertyUpdate.is_multi_picklist) {
          switch (propertyUpdate.multi_picklist_mode) {
            case MultiPicklistUpdateMode.Add:
              return `add ${picklistValues} to ${property.labelTitleDisplay}`;
            case MultiPicklistUpdateMode.Replace:
              return `replace ${property.labelTitleDisplay} with ${picklistValues}`;
            case MultiPicklistUpdateMode.Remove:
              return `remove ${picklistValues} from ${property.labelTitleDisplay}`;
            case MultiPicklistUpdateMode.Clear:
              return `clear all values from ${property.labelTitleDisplay}`;
          }
        }

        let valueStr: string;
        if (propertyUpdate.value_to_update_to_formula?.length > 0) {
          valueStr = '(formula)';
        } else {
          switch (property.property_type) {
            case ObjectModelPropertyRootType.PickList:
              valueStr = picklistValues;
              break;
            case ObjectModelPropertyRootType.DateTime:
              valueStr = DatetimeHelper.formatDate(
                DatetimeHelper.parseDate(propertyUpdate.value_to_update_to),
                DatetimeHelper.timezone,
                DatetimeHelper.displayFormat(property.datetime_mode),
              );
              break;
            default:
              valueStr = propertyUpdate.value_to_update_to;
          }
        }

        return `change ${property.labelTitleDisplay} to ${valueStr}`;
      }).filter(x => x !== null);

      if (strings.length > 0) {
        strings[0] = StringHelper.capitalize(strings[0]);
      }

      return ArrayHelper.toSentence(strings);
    },
  },
}